export interface CourseAccessInputs {
  ownedByViewer: boolean;
  isAdmin: boolean;
}

/**
 * Whether the viewer can watch the full course: only a course purchase
 * (`ownedByViewer`) or an admin account grants access — an Autoclipper plan
 * subscription does not. Mirrors the backend's module-lock rule
 * (`!is_free && !ownsCourse && !isAdmin`).
 */
export function hasCourseAccess(i: CourseAccessInputs): boolean {
  return i.ownedByViewer || i.isAdmin;
}
